import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData,
  type CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostError,
  type CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponse,
  createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPost,
} from '../../generated';

export type CreateUnlistedPdpMutationVariables = CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData['path'] &
  CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData['body'];

export type CreateUnlistedPdpMutation = CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponse;

export const useCreateUnlistedPdpMutation = <
  TError = CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreateUnlistedPdpMutation, TError, CreateUnlistedPdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreateUnlistedPdpMutation, TError, CreateUnlistedPdpMutationVariables, TContext>({
    mutationKey: ['CreateUnlistedPdp'],
    mutationFn: async ({ portfolio_id, ...body }: CreateUnlistedPdpMutationVariables) => {
      const { data } = await createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPost({
        path: { portfolio_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreateUnlistedPdpMutation.fetcher = (
  { portfolio_id, ...body }: CreateUnlistedPdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPost({
      path: { portfolio_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
